import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { LEVEL_LABELS } from "@/lib/api";

export default function GateModal({ open, onClose, unlockData, targetLevel, onStartPrev }) {
  if (!unlockData) return null;
  const { requiredCorrect, bestCorrect, missingCorrect, prevLevel, prevQuestionCount, thresholdPercent } = unlockData;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#121214] border-white/10 text-white max-w-md" data-testid="gate-modal">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
              <Lock className="w-5 h-5 text-amber-400" />
            </div>
            <DialogTitle className="font-outfit text-xl">Level noch nicht freigeschaltet</DialogTitle>
          </div>
          <DialogDescription className="text-[#9CA3AF] text-sm leading-relaxed">
            Für <span className="text-white font-semibold">{LEVEL_LABELS[targetLevel]}</span> brauchst du mindestens{' '}
            <span className="text-amber-400 font-semibold">{thresholdPercent}%</span> im Level{' '}
            <span className="text-white font-semibold">{LEVEL_LABELS[prevLevel]}</span>.
            <br /><br />
            Erforderlich: <span className="text-white font-mono">{requiredCorrect}/{prevQuestionCount}</span>
            <br />
            Dein Bestwert: <span className="text-white font-mono">{bestCorrect}/{prevQuestionCount}</span>
            <br />
            Es fehlen: <span className="text-amber-400 font-mono font-bold">{missingCorrect} richtige</span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-3 mt-4">
          <Button variant="outline" onClick={onClose} className="border-white/10 text-[#9CA3AF] hover:bg-white/5" data-testid="gate-modal-cancel">
            Abbrechen
          </Button>
          <Button onClick={onStartPrev} className="bg-[#3B82F6] hover:bg-[#2563EB] text-white" data-testid="gate-modal-start-prev">
            {LEVEL_LABELS[prevLevel]} starten
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
